import { render, staticRenderFns } from "./DashGraph.vue?vue&type=template&id=532a9b84&scoped=true"
import script from "./DashGraph.vue?vue&type=script&lang=js"
export * from "./DashGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532a9b84",
  null
  
)

export default component.exports